import { UserCog, ExternalLink } from "lucide-react";

// Renders an editor "bubble". If the editor has a link, it becomes a clickable
// anchor that opens the external site in a new tab.
export function EditorBubble({ name, color, link, className = "px-2 py-0.5 text-[11px]", iconClass = "h-3 w-3", showIcon = true, testid }) {
  if (!name) return null;
  const base = `editor-bubble inline-flex items-center gap-1 rounded-full font-medium ${className} ${link ? "cursor-pointer hover:brightness-110" : ""}`;
  const style = { "--editor-color": color };
  const inner = (
    <>
      {showIcon && <UserCog className={iconClass} />}
      {name}
      {link && <ExternalLink className="ml-0.5 h-2.5 w-2.5 opacity-70" />}
    </>
  );
  if (link) {
    return (
      <a href={link} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()}
        className={base} style={style} data-testid={testid || "editor-bubble-link"} title={`Open ${name}'s link`}>
        {inner}
      </a>
    );
  }
  return <span className={base} style={style}>{inner}</span>;
}
